import { forwardRef } from 'react'

import {
  Cluster,
  Icon,
  Label,
  Radio,
  Stack,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
  Typography,
} from '@forto-dev/phoenix-ui-core'

import { useLocalisation } from '@/utils/localisation'

import { HblType } from '../../domain/hbl'

type HBLSelectorProps = {
  value: HblType | undefined
  onChange: (newValue: HblType) => void
  disabled?: boolean
}

export const HBLSelector = forwardRef<HTMLInputElement, HBLSelectorProps>(
  ({ value, disabled, onChange, ...rest }, ref) => {
    const { translate } = useLocalisation()
    const hblTypes = ['express', 'original'] as const
    return (
      <Stack gap={2}>
        <Cluster gap={4}>
          <Label>{translate('details.details.general.edit.fields.hblType.label')}</Label>
          {disabled ? (
            <Tooltip>
              <TooltipTrigger>
                <Icon name="HelpCircle" size="sm" />
              </TooltipTrigger>
              <TooltipContent>{translate('details.details.general.edit.fields.incoTerms.tooltip')}</TooltipContent>
            </Tooltip>
          ) : null}
        </Cluster>
        <Cluster gap={8}>
          {hblTypes.map((type) => (
            <Radio
              key={type}
              id={`hbl-type-${type}`}
              label={<Typography>{translate(`shipment.bill_of_lading_type.${type}`)}</Typography>}
              checked={value === type}
              onChange={(checked) => {
                if (checked) {
                  onChange(type)
                }
              }}
              disabled={disabled}
              ref={ref}
              {...rest}
            />
          ))}
        </Cluster>
      </Stack>
    )
  }
)
